import ApiGateway from "../api.gateway";
import ApiService from "../api.services";
import { TokenService } from "../auth/storage.services";
import { GatewayService } from "../auth/gateway.services";

class AuthenticationError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

const UserService = {
  login: async function (username, password) {
    const requestData = {
      username,
      password,
    };

    try {
      const response = await ApiService.post("/api/auth/login", requestData);
      //const gateway = await GatewayService.login(username, password);
      //TokenService.saveGateway(gateway);
      return response.data;
    } catch (error) {
      throw new AuthenticationError(401, error.message);
    }
  },
  me: async function () {
    try {
      const response = await ApiService.get("/api/auth/me");
      return response.data;
    } catch (error) {
      throw new AuthenticationError(401, error.message);
    }
  },
  favorite: async function (name) {
    try {
      const response = await ApiService.put(`/api/users/favorite/${name}`);
      return response.data;
    } catch (error) {
      throw new AuthenticationError(401, error.message);
    }
  },
  changeOwnPassword: async function (password) {
    const response = await ApiService.patch("/api/auth/me/password", { password });
    return response.data;
  },
  impersonationAllowed: async function () {
    const response = await ApiService.get("/api/auth/impersonation/allowed");
    return response.data.allowed;
  },
  impersonate: async function (id) {
    const response = await ApiService.post(`/api/auth/impersonation/${id}`);
    return response.data;
  },
  impersonationHistory: async function (id) {
    const response = await ApiService.get(`/api/auth/impersonation/${id}/history`);
    return response.data;
  },
  acceptTerms: async function () {
    try {
      const response = await ApiService.patch("api/auth/me/accept-terms");
      return response.data;
    } catch (error) {
      throw new AuthenticationError(401, error.message);
    }
  },
  menu: async function () {
    try {
      const response = await ApiService.get("/api/auth/menu");
      return response.data;
    } catch (error) {
      throw new AuthenticationError(401, error.message);
    }
  },
  listNotifications: async function () {
    try {
      const response = await ApiService.get(
        `/api/users/notification/list/pendencies`
      );
      return response.data;
    } catch (error) {
      throw new AuthenticationError(401, error.message);
    }
  },
  notifications: async function (id) {
    try {
      const response = await ApiService.get(`/api/users/notification/${id}`);
      return response.data;
    } catch (error) {
      throw new AuthenticationError(401, error.message);
    }
  },
  list: async function (records, page, search) {
    try {
      const response = await ApiService.get(
        `/api/users/records/${records}/${page}?search=${search}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  role: async function (data) {
    try {
      const response = await ApiService.get(`/api/users/role/${data}`);
      return response.data;
    } catch (error) {
      throw error;
    }

  },
  type: async function (type) {
    try {
      const response = await ApiService.get(`/api/users/type/${type}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  customer: async function (customer) {
    try {
      const response = await ApiService.get(`/api/users?customer=${customer}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  pdv: async function () {
    try {
      const response = await ApiService.get(`/api/users/pdv`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  get: async function (id) {
    try {
      const response = await ApiService.get(`/api/users/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  add: async function (
    name,
    mail,
    active,
    username,
    type,
    password,
    role,
    customer,
    department,
    pdv,
    authorization,
    customerPdv,
    phone,
    team,
    imei
  ) {
    const data = {
      name,
      mail,
      active,
      username,
      type,
      password,
      role,
      customer,
      department,
      pdv,
      authorization,
      customerPdv,
      phone,
      team,
      imei,
    };
    try {
      const response = await ApiService.post("/api/users", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  profile: async function (form) {
    const data = {
      user: form,
    };
    try {
      const response = await ApiService.post("/api/users/profile", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  update: async function (
    id,
    name,
    mail,
    active,
    type,
    password,
    role,
    customer,
    department,
    pdv,
    authorization,
    customerPdv,
    phone,
    team,
    imei
  ) {
    const data = {
      user: {
        name,
        mail,
        active,
        type,
        password,
        role,
        customer,
        department,
        pdv,
        authorization,
        customerPdv,
        phone,
        team,
        imei,
      },
    };
    try {
      const response = await ApiService.put(`/api/users/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async function (id) {
    try {
      const response = await ApiService.delete(`/api/users/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  logout() {
    TokenService.removeToken();
    ApiService.removeHeader();
    ApiGateway.removeHeader();
  },
  forget: async function (username, mail) {
    const data = {
      user: {
        username,
        mail,
      },
    };
    try {
      const response = await ApiService.post("/api/forget", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default UserService;

export { UserService, AuthenticationError };
